import { useState, useEffect, useCallback } from 'react';
import {
  getSofaMatchIncidents,
  sofaIncidentToTimeline,
  TimelineItem,
} from '@/services/api/sofascore';

/**
 * Busca a timeline de incidentes (gols, cartões, períodos) de uma partida do
 * SofaScore. Atualiza em tempo real (20s) enquanto o jogo está ao vivo.
 *
 * @param sofaEventId id do evento no SofaScore (string numérica) ou null
 * @param isLive      se true, faz polling para atualizar a timeline
 */
export function useMatchIncidents(sofaEventId: string | null, isLive: boolean) {
  const [items, setItems] = useState<TimelineItem[]>([]);
  const [loading, setLoading] = useState(!!sofaEventId);

  const fetchIncidents = useCallback(async () => {
    if (!sofaEventId) {
      setItems([]);
      setLoading(false);
      return;
    }
    try {
      const incidents = await getSofaMatchIncidents(Number(sofaEventId));
      const mapped = incidents
        .map(sofaIncidentToTimeline)
        .filter((x): x is TimelineItem => x !== null);
      setItems(mapped);
    } catch {
      // mantém a timeline atual em caso de erro
    } finally {
      setLoading(false);
    }
  }, [sofaEventId]);

  useEffect(() => {
    fetchIncidents();
    if (!isLive || !sofaEventId) return;
    const timer = setInterval(fetchIncidents, 20_000);
    return () => clearInterval(timer);
  }, [fetchIncidents, isLive, sofaEventId]);

  return { items, loading };
}
